import HttpClient from './utils/HttpClient';

class AppointmentRecurrenceTypesService {
  constructor(baseUrl) {
    
    this.baseUrl = baseUrl;

    this.httpClient = new HttpClient(this.baseUrl)
  }

  async listAppointmentRecurrenceTypes() {
    const urlPath = '/appointmentrecurrencetypes/get-all';

    return this.httpClient.get(urlPath);
  }
}

export default AppointmentRecurrenceTypesService;